import { createSlice } from "@reduxjs/toolkit";
import { inviteErnings, claimInviteErnings } from "./InviteActions";

const initialState = {
    loading: false,
    earning: {},
    error: null,
    success: false, // for monitoring the registration process.
  }

const InviteSlice = createSlice({
    name: "InviteSlice",
    initialState,
    reducers: {},
    extraReducers:{
        [inviteErnings.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.earning = payload.data
        },
        [inviteErnings.pending]: (state, {payload}) => {
            state.loading = true
        },
        [inviteErnings.rejected]: (state, {payload}) => {
            state.loading = false
            state.earning = payload
        },
        [claimInviteErnings.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.success = true
            state.earning = payload.data
        },
        [claimInviteErnings.pending]: (state, {payload}) => {
            state.loading = true
        },
        [claimInviteErnings.rejected]: (state, {payload}) => {
            state.loading = false
            state.earning = payload
        },
    }
})

export default InviteSlice.reducer